import { useMemo } from 'react';
import { ListComponentBaseProps } from '../../entity-list/interface';
import { TableRow } from '../../table/interfaces/table';
import { Table } from '../../table/Table';
import { UsageSummary, UsageSummaryBillingCycle } from './interface';
import { getUsageSummaryColumns } from './UsageSummaryColumns';

export interface UsageSummaryTableProps extends ListComponentBaseProps<UsageSummary[]> {
  headerStats: UsageSummaryBillingCycle[];
  isMultiRegion: boolean;
  isH20Enabled: boolean;
}

export function UsageSummaryTable({
  data: usageSummary,
  headerStats,
  isMultiRegion,
  isH20Enabled,
  tableProps
}: UsageSummaryTableProps) {
  const columns = useMemo(() => {
    const activeCount = usageSummary.filter(summary => !summary.isDeleted).length;
    const totalCount = usageSummary.length;

    return getUsageSummaryColumns(
      activeCount,
      totalCount,
      headerStats,
      isMultiRegion,
      isH20Enabled
    );
  }, [headerStats, isMultiRegion, isH20Enabled, usageSummary]);

  const rows: TableRow<UsageSummary>[] = useMemo(() => {
    return usageSummary.map(summary => ({
      data: summary,
      tabIndex: 0,
      id: summary.pipelineId
    }));
  }, [usageSummary]);

  return <Table columns={columns} rows={rows} {...tableProps} forceFullWidth />;
}
